import React, { FC, useState, useRef, useEffect } from "react";
import { Container } from "../../components/Container/index";
import { Button, Space } from "antd";
import styles from "./styles.module.less";
import querystring from "query-string";
import { Protocol } from "../../config";
import { useTitle } from "../../hooks/useTitle";
import { useTranslation } from "react-i18next";
import Axios from "axios";
import { dataHandle } from "./utils";
export const AuthorizePage: FC = () => {
  const { t } = useTranslation();
  useTitle(t("common.authoriztion"));
  const [formHidden, setFormHidden] = useState({
    action: "",
    acceptedScopes: [],
    rejectedScopes: [],
  });
  const [confirmBtnLoading, setConfirmBtnLoading] = useState(false);
  const submitBtn = useRef<any>();
  // const [select, setSelect] = React.useState(rolesList || []);
  const [resource, setResource] = useState<any>();
  const query = querystring.parse(window.location.search);
  const uuid = query["uuid"];
  const protocol = window.__config__.protocol;
  // const scope = JSON.parse((query["scopes"] as string) ?? "[]");
  let urlParams = { ...query };
  const { app_id, scopes } = urlParams;
  useEffect(() => {
    let url = `/api/v2/applications/${app_id}/authorization/scopeDetails`;
    Axios.get(url, {
      params: {
        scopes,
      },
    }).then((response: any) => {
      const { viewData: newViewData, requestData: newRequestData } = dataHandle(
        response?.new
      );
      const { viewData: acceptedViewData, requestData: acceptedRequestData } =
        dataHandle(response?.accepted);
      const { viewData: rejectedViewData, requestData: rejectedRequestData } =
        dataHandle(response?.rejected);
      setResource({
        viewData: [...newViewData, ...acceptedViewData, ...rejectedViewData],
        requestData: [
          ...newRequestData,
          ...acceptedRequestData,
          ...rejectedRequestData,
        ],
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const onCancel = () => {
    if (protocol === Protocol.OIDC) {
      setFormHidden({
        action: `/interaction/oidc/${uuid}/abort`,
        acceptedScopes: [],
        rejectedScopes: [],
      });
    }

    if (protocol === Protocol.OAUTH) {
      setFormHidden({
        action: `/interaction/oauth/abort`,
        acceptedScopes: [],
        rejectedScopes: [],
      });
    }

    setTimeout(() => submitBtn.current.click(), 0);
  };

  const onConfirm = () => {
    setConfirmBtnLoading(true);

    if (protocol === Protocol.OIDC) {
      setFormHidden({
        action: `/interaction/oidc/${uuid}/confirm`,
        acceptedScopes: [...resource.requestData] as never[],
        rejectedScopes: [] as never[],
      });
    }

    if (protocol === Protocol.OAUTH) {
      setFormHidden({
        action: `/interaction/oauth/confirm`,
        acceptedScopes: [...resource.requestData] as never[],
        rejectedScopes: [] as never[],
      });
    }

    setTimeout(() => submitBtn.current.click(), 0);
    // 两秒后取消授权 btn loading 状态
    setTimeout(() => {
      setConfirmBtnLoading(false);
    }, 2000);
  };

  const userSelectList = (resource: string[] = []) => {
    return (
      <div className={styles.roles_box}>
        {resource.map((item: any) => {
          return <li key={item?.desc}>{item?.desc}</li>;
        })}
      </div>
    );
  };

  return (
    <Container minHeight="auto">
      <Space size={32} align="center" className={styles.header}>
        <div className={styles.title}>{t("common.authApp")}</div>
        <div className={styles.user_img_box}>
          {/* <img
            className={styles.user_img}
            src={window.__user__?.photo ?? ""}
            alt=""
          /> */}
          {/* <SwapOutlined style={{ fontSize: 35, color: "#ccc" }} /> */}
          <img
            className={styles.user_img}
            src={window.__config__?.logo ?? ""}
            alt=""
          />
        </div>
      </Space>

      <div className={styles.body}>
        <div className={styles.app_info}>
          <div style={{ textAlign: "left" }}>
            {t("common.empower")}{" "}
            <span className={styles.website_name}>
              {window.__config__.name}
            </span>{" "}
            {t("common.rolesMessage")}
          </div>
        </div>
        {userSelectList(resource?.viewData)}

        {/* <p>
          {t("common.authAppSomePermisson", {
            name: window.__config__.name,
          })}
        </p>

        <ul>
          <li>{t("common.visitPersonalAccData")}</li>
        </ul> */}
      </div>

      <div style={{ flex: 1 }}></div>

      <div className={styles.footer}>
        <Button
          size="large"
          style={{ width: 160, borderRadius: 4 }}
          onClick={onCancel}
        >
          {t("common.cancel")}
        </Button>
        <Button
          type="primary"
          size="large"
          style={{ width: 160, borderRadius: 4 }}
          onClick={onConfirm}
          loading={confirmBtnLoading}
        >
          {t("common.authoriztion")}
        </Button>
      </div>
      <form
        action={formHidden.action}
        method="post"
        style={{ display: "none" }}
      >
        {formHidden.acceptedScopes.map((item: any) => {
          return (
            <input
              type="text"
              key={item?.scope}
              name="consent[acceptedScopes][]"
              value={item?.scope}
            />
          );
        })}
        <button ref={submitBtn} type="submit"></button>
      </form>
    </Container>
  );
};
